import { apiClient } from '@/services';
import type { ApiResponse } from '@macroinsight/shared-types';
import { type Profile, profileSchema } from './types';

export type { Profile };

export async function getProfile(): Promise<ApiResponse<Profile>> {
  const response = await apiClient.get<Profile>('/api/profile');

  if (response.success && response.data) {
    const validated = profileSchema.safeParse(response.data);
    if (validated.success) {
      return {
        success: true,
        data: validated.data,
        message: response.message
      };
    }
    return {
      success: false,
      data: null,
      message: 'Invalid profile data format'
    };
  }

  return response;
}
